module.exports = __webpack_public_path__ + "static/media/Artboard2.d2f9e46f.png";